import { useEffect, useState } from "react";

/**
 * False on the server and on the browser's first render, true from the next render on.
 *
 * The first browser render must match the server HTML exactly or React 18 throws the HTML away and
 * renders again. Anything that only the browser knows (the time, `router.isReady` on a statically
 * generated page, which is false on the server and true in the browser at once) waits for this.
 */
export const useHydrated = (): boolean => {
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => setHydrated(true), []);
    return hydrated;
};
